const items = [
  "Mobilier la comandă",
  "Lemn masiv · MDF · PAL",
  "Bucătării moderne",
  "Dressinguri & dulapuri",
  "Uși și scări din lemn",
  "Mese masive",
  "Montaj profesionist",
  "Garanție pentru fiecare lucrare",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-line bg-sand py-5"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-serif text-xl italic text-walnut/80 sm:text-2xl">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-oak/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
